<div class="post-completion-promo-modal">
  <div class="container">
    <!-- Close -->
    <button mat-icon-button class="close-btn" (click)="close()">
      <mat-icon fontSet="material-icons-outlined">close</mat-icon>
    </button>

    <!-- Content -->
    <div class="content">
      <p class="message" [innerHTML]="modalText">
      </p>
    </div>

    <!-- Footer Actions -->
    <div class="actions">
      <button class="def-button" (click)="onCtaClick()">
        {{ buttonLabel }}
      </button>
    </div>
  </div>
</div>
